import React from "react";

const SvgPerformance = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      d="M15.962 9.408a.91.91 0 0 1 0 1.286l-2.594 2.593a1.73 1.73 0 0 1-1.685 2.132 1.734 1.734 0 0 1 0-3.465c.137 0 .27.017.4.047l2.593-2.593a.91.91 0 0 1 1.286 0zm3.112-3.474c3.369 3.369 3.891 8.684 1.242 12.637a.909.909 0 1 1-1.511-1.013 8.125 8.125 0 0 0 1.325-3.617h-.855a.91.91 0 0 1 0-1.818h.858a8.188 8.188 0 0 0-1.727-4.21l-.619.618a.907.907 0 0 1-1.286 0 .91.91 0 0 1 0-1.286l.621-.622a8.146 8.146 0 0 0-4.174-1.742v.85a.91.91 0 0 1-1.82 0v-.858a8.15 8.15 0 0 0-4.25 1.75l.62.622A.91.91 0 1 1 6.214 8.53l-.62-.62a8.19 8.19 0 0 0-1.726 4.212h.858a.91.91 0 0 1 0 1.818H3.87a8.126 8.126 0 0 0 1.325 3.617.91.91 0 0 1-1.511 1.013c-2.649-3.953-2.127-9.268 1.24-12.637 3.903-3.9 10.25-3.9 14.15 0zm-2.975 11.723a.91.91 0 0 1 0 1.819H7.9a.91.91 0 0 1 0-1.82H16.1z"
      id="Performance_svg__a"
    />
  </svg>
);

export default SvgPerformance;
